








import { Component, Prop, Vue } from 'vue-property-decorator'
import { State } from '@/types/reservation'

@Component
export default class ReservationStateSelect extends Vue {
  @Prop() readonly value!: State
  @Prop({ default: () => '' }) readonly label!: string

  get options() {
    return [
      { text: this.$t('reservation.stateSelect.text.waiting'), value: State.New },
      { text: this.$t('reservation.stateSelect.text.visited'), value: State.Served },
      { text: this.$t('reservation.stateSelect.text.cancel'), value: State.Cancel, disabled: true },
      { text: this.$t('reservation.stateSelect.text.noShow'), value: State.NoShow },
    ]
  }
}
